// Parser local de claims JWT.
//
// IMPORTANTE: este parser NO verifica la firma del token. La verificación
// real ocurre en el backend (apps/api/src/middleware/auth.ts via jose).
//
// El propósito acá es UI-only: leer los claims del JWT activo para saber
// si la sesión tiene los custom claims (tenant_id_activo, rol, etc.) que
// el backend va a aceptar, y mostrar la pantalla correcta:
//   - Si NO hay claims custom → "incomplete_claims" (mostrar error)
//   - Si SÍ los hay → usar `tenants_disponibles` para L0, `rol` para
//     decidir qué pantallas mostrar
//
// El hook GoTrue (migración 00012) es el que inyecta los claims al firmar.

import { jwtClaimsSchema, type JwtClaims } from 'schemas';

/**
 * Decodifica el payload de un JWT (sin verificar firma).
 * Retorna null si el token está malformed o los claims no matchean el schema.
 */
export function parseClaimsFromToken(token: string | undefined | null): JwtClaims | null {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;

  try {
    const payloadB64 = parts[1];
    if (!payloadB64) return null;
    // base64url → base64
    const padded = payloadB64.replace(/-/g, '+').replace(/_/g, '/');
    const padding = '='.repeat((4 - (padded.length % 4)) % 4);
    const decoded = atob(padded + padding);
    const payload = JSON.parse(decoded);
    const parsed = jwtClaimsSchema.safeParse(payload);
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}
